var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00078 16.2C12.9772 16.2 16.2008 12.9765 16.2008 9.00005C16.2008 5.0236 12.9772 1.80005 9.00078 1.80005C5.02433 1.80005 1.80078 5.0236 1.80078 9.00005C1.80078 12.9765 5.02433 16.2 9.00078 16.2ZM12.3372 7.83644C12.6886 7.48497 12.6886 6.91512 12.3372 6.56365C11.9857 6.21218 11.4159 6.21218 11.0644 6.56365L8.10078 9.52726L6.93718 8.36365C6.5857 8.01218 6.01586 8.01218 5.66438 8.36365C5.31291 8.71512 5.31291 9.28497 5.66438 9.63645L7.46438 11.4364C7.81585 11.7879 8.3857 11.7879 8.73717 11.4364L12.3372 7.83644Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.47303a4bf670ac2e5306b882e3379ac9.svg";
export { ForwardRef as ReactComponent };